import equilibrium from './spec/equilibrium.js';
import genshiro from './spec/genshiro.js';
import hyperbridge from './spec/hyperbridge.js';
import interbtc from './spec/interbtc.js';
import mangata from './spec/mangata.js';
import subspace from './spec/subspace.js';
const mapping = [
    [equilibrium, ['Equilibrium', 'Equilibrium-parachain']],
    [genshiro, ['Genshiro', 'Gens-parachain']],
    [interbtc, ['interbtc-parachain', 'interbtc-standalone', 'interlay-parachain', 'kintsugi-parachain', 'testnet-kintsugi', 'testnet-interlay']],
    [subspace, ['subspace']],
    [mangata, ['mangata', 'mangata-parachain']]
];
const specMappings = [
    [hyperbridge, ['nexus', 'messier', 'gargantua']]
];
export function applyDerives(typesBundle) {
    mapping.forEach(([{ derives }, chains]) => {
        chains.forEach((chain) => {
            if (typesBundle.spec?.[chain]) {
                typesBundle.spec[chain].derives = derives;
            }
        });
    });
    specMappings.forEach(([spec, chains]) => {
        chains.forEach((chain) => {
            if (typesBundle.spec?.[chain]) {
                typesBundle.spec[chain] = spec;
            }
        });
    });
    return typesBundle;
}
